import { render } from "@testing-library/react";

export const RadarData = {
  labels: [
    "ضخامت دوده سخت",
    "سازگاری با سیستم پایش",
    "مصرف سوخت",
    "غلظت سوختگی",
    "رسوبات پیستون",
    " لجن",
    " سائیدگی",
  ],
  datasets: [
    {
      label: "C5-16",
      backgroundColor: "rgba(34, 202, 236, .2)",
      borderColor: "rgba(34, 202, 236, 1)",
      pointBackgroundColor: "rgba(34, 202, 236, 1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(34, 202, 236, 1)",
      data: [8, 6, 8, 6, 8, 7, 6],
    },
    {
      label: "C4-16",
      backgroundColor: "rgba(72, 100, 50, .5)",
      borderColor: "rgba(72, 100, 50, .8)",
      pointBackgroundColor: "rgba(72, 100, 50, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(72, 100, 50, .8)",
      data: [8, 9, 3, 6, 8, 7, 6],
    },
    {
      label: "C3-16",
      backgroundColor: "rgba(255, 247, 0, .5)",
      borderColor: "rgba(255, 247, 0, .5)",
      pointBackgroundColor: "rgba(255, 247, 0, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 247, 0, .5)",
      data: [8, 6, 3, 6, 8, 7, 6],
    },
    {
      label: "C2-16",
      backgroundColor: "rgba(0, 255, 26, .5)",
      borderColor: "rgba(0, 255, 26, .5)",
      pointBackgroundColor: "rgba(0, 255, 26, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 26, .5)",
      data: [8, 6, 7, 6, 8, 7, 6],
    },
    {
      label: "C1-16",
      backgroundColor: "rgba(0, 217, 255, .5)",
      borderColor: "rgba(0, 217, 255, .5)",
      pointBackgroundColor: "rgba(0, 217, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 217, 255, .5)",
      data: [8, 9, 8, 6, 8, 7, 6],
    },
    {
      label: "A5/B5-16",
      backgroundColor: "rgba(255, 0, 217, .5)",
      borderColor: "rgba(255, 0, 217, .5)",
      pointBackgroundColor: "rgba(255, 0, 217, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 0, 217, .5)",
      data: [8, 0, 7, 6, 8, 7, 6],
    },
    {
      label: "A3/B3-16",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [8, 0, 5, 7, 7, 6],
    },
    {
      label: "A3/B4-16",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [8, 0, 5, 8, 7, 6],
    },
    {
      label: "C4-12",
      backgroundColor: "rgba(34, 202, 236, .2)",
      borderColor: "rgba(34, 202, 236, 1)",
      pointBackgroundColor: "rgba(34, 202, 236, 1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(34, 202, 236, 1)",
      data: [8, 6, 8, 6, 8, 7, 6],
    },
    {
      label: "C3-12",
      backgroundColor: "rgba(72, 100, 50, .5)",
      borderColor: "rgba(72, 100, 50, .8)",
      pointBackgroundColor: "rgba(72, 100, 50, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(72, 100, 50, .8)",
      data: [8, 9, 3, 6, 8, 7, 6],
    },
    {
      label: "C2-12",
      backgroundColor: "rgba(255, 247, 0, .5)",
      borderColor: "rgba(255, 247, 0, .5)",
      pointBackgroundColor: "rgba(255, 247, 0, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 247, 0, .5)",
      data: [8, 6, 3, 6, 8, 7, 6],
    },
    {
      label: "C1-12",
      backgroundColor: "rgba(0, 255, 26, .5)",
      borderColor: "rgba(0, 255, 26, .5)",
      pointBackgroundColor: "rgba(0, 255, 26, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 26, .5)",
      data: [8, 6, 7, 6, 8, 7, 6],
    },
    {
      label: "A5/B5-12",
      backgroundColor: "rgba(0, 217, 255, .5)",
      borderColor: "rgba(0, 217, 255, .5)",
      pointBackgroundColor: "rgba(0, 217, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 217, 255, .5)",
      data: [8, 9, 8, 6, 8, 7, 6],
    },
    {
      label: "A3/B4-12",
      backgroundColor: "rgba(255, 0, 217, .5)",
      borderColor: "rgba(255, 0, 217, .5)",
      pointBackgroundColor: "rgba(255, 0, 217, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 0, 217, .5)",
      data: [8, 0, 7, 6, 8, 7, 6],
    },
    {
      label: "A3/B3-12",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [8, 0, 5, 7, 7, 6],
    },
    {
      label: "A1/B1-12",
      backgroundColor: "rgba(109, 110, 113, .2)",
      borderColor: "rgba(109, 110, 113, .2)",
      pointBackgroundColor: "rgba(109, 110, 113, .2)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(34, 202, 236, 1)",
      data: [8, 0, 5, 8, 7, 6],
    },
    {
      label: "C4-10",
      backgroundColor: "rgba(109, 110, 113, .2)",
      borderColor: "rgba(109, 110, 113, .2)",
      pointBackgroundColor: "rgba(109, 110, 113, .2)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(34, 202, 236, 1)",
      data: [7, 9, 3, 5, 7, 7, 6],
    },
    {
      label: "C3-10",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .8)",
      pointBackgroundColor: "rgba(0, 104, 173, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .8)",
      data: [7, 6, 3, 5, 7, 7, 6],
    },
    {
      label: "C2-10",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .5)",
      pointBackgroundColor: "rgba(0, 104, 173, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .5)",
      data: [7, 6, 7, 5, 7, 7, 6],
    },
    {
      label: "C1-10",
      backgroundColor: "rgba(0, 255, 26, .5)",
      borderColor: "rgba(0, 255, 26, .5)",
      pointBackgroundColor: "rgba(0, 255, 26, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 26, .5)",
      data: [8, 6, 7, 6, 8, 7, 6],
    },
    {
      label: "A5/B5-10",
      backgroundColor: "rgba(0, 217, 255, .5)",
      borderColor: "rgba(0, 217, 255, .5)",
      pointBackgroundColor: "rgba(0, 217, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 217, 255, .5)",
      data: [8, 9, 8, 6, 8, 7, 6],
    },
    {
      label: "A3/B4-10",
      backgroundColor: "rgba(255, 0, 217, .5)",
      borderColor: "rgba(255, 0, 217, .5)",
      pointBackgroundColor: "rgba(255, 0, 217, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 0, 217, .5)",
      data: [8, 0, 7, 6, 8, 7, 6],
    },
    {
      label: "A3/B3-10",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [8, 0, 5, 7, 7, 6],
    },
    {
      label: "A1/B1-10",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [8, 0, 5, 8, 7, 6],
    },
    {
      label: "C4-08",
      backgroundColor: "rgba(109, 110, 113, .2)",
      borderColor: "rgba(109, 110, 113, .2)",
      pointBackgroundColor: "rgba(109, 110, 113, .2)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(34, 202, 236, 1)",
      data: [7, 9, 3, 5, 7, 7, 6],
    },
    {
      label: "C3-08",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .8)",
      pointBackgroundColor: "rgba(0, 104, 173, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .8)",
      data: [7, 6, 3, 5, 7, 7, 6],
    },
    {
      label: "C2-08",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .5)",
      pointBackgroundColor: "rgba(0, 104, 173, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .5)",
      data: [7, 6, 7, 5, 7, 7, 6],
    },
    {
      label: "C1-08",
      backgroundColor: "rgba(0, 255, 26, .5)",
      borderColor: "rgba(0, 255, 26, .5)",
      pointBackgroundColor: "rgba(0, 255, 26, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 26, .5)",
      data: [7, 9, 8, 5, 7, 7, 6],
    },
    {
      label: "A5/B5-08",
      backgroundColor: "rgba(0, 217, 255, .5)",
      borderColor: "rgba(0, 217, 255, .5)",
      pointBackgroundColor: "rgba(0, 217, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 217, 255, .5)",
      data: [7, 0, 7, 5, 7, 7, 6],
    },
    {
      label: "A3/B4-08",
      backgroundColor: "rgba(255, 0, 217, .5)",
      borderColor: "rgba(255, 0, 217, .5)",
      pointBackgroundColor: "rgba(255, 0, 217, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 0, 217, .5)",
      data: [7, 0, 5, 7, 7, 6],
    },
    {
      label: "A3/B3-08",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [7, 0, 5, 5, 7, 5],
    },
    {
      label: "A1/B1-08",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [7, 0, 7, 4, 5, 4, 5],
    },
    {
      label: "C4-07",
      backgroundColor: "rgba(109, 110, 113, .2)",
      borderColor: "rgba(109, 110, 113, .2)",
      pointBackgroundColor: "rgba(109, 110, 113, .2)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(34, 202, 236, 1)",
      data: [7, 9, 3, 5, 7, 7, 5],
    },
    {
      label: "C3-07",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .8)",
      pointBackgroundColor: "rgba(0, 104, 173, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .8)",
      data: [7, 6, 3, 5, 7, 4, 5],
    },
    {
      label: "C2-07",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .5)",
      pointBackgroundColor: "rgba(0, 104, 173, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .5)",
      data: [7, 6, 7, 5, 7, 4, 4],
    },
    {
      label: "C1-07",
      backgroundColor: "rgba(0, 255, 26, .5)",
      borderColor: "rgba(0, 255, 26, .5)",
      pointBackgroundColor: "rgba(0, 255, 26, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 26, .5)",
      data: [7, 9, 7, 5, 4, 7, 4],
    },
    {
      label: "A5/B5-07",
      backgroundColor: "rgba(0, 217, 255, .5)",
      borderColor: "rgba(0, 217, 255, .5)",
      pointBackgroundColor: "rgba(0, 217, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 217, 255, .5)",
      data: [6, 0, 7, 5, 9, 4, 4],
    },
    {
      label: "A3/B4-07",
      backgroundColor: "rgba(255, 0, 217, .5)",
      borderColor: "rgba(255, 0, 217, .5)",
      pointBackgroundColor: "rgba(255, 0, 217, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 0, 217, .5)",
      data: [6, 0, 5, 7, 4, 6],
    },
    {
      label: "A3/B3-07",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [6, 0, 5, 6, 4, 4],
    },
    {
      label: "A1/B1-07",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [6, 0, 7, 4, 6, 4, 4],
    },
    {
      label: "C3-04",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .8)",
      pointBackgroundColor: "rgba(0, 104, 173, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .8)",
      data: [5, 6, 3, 5, 6, 4, 5],
    },
    {
      label: "C2-04",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .5)",
      pointBackgroundColor: "rgba(0, 104, 173, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .5)",
      data: [5, 6, 7, 5, 7, 4, 5],
    },
    {
      label: "C1-04",
      backgroundColor: "rgba(0, 255, 26, .5)",
      borderColor: "rgba(0, 255, 26, .5)",
      pointBackgroundColor: "rgba(0, 255, 26, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 26, .5)",
      data: [5, 9, 7, 5, 7, 4, 4],
    },
    {
      label: "A5/B5-04",
      backgroundColor: "rgba(0, 217, 255, .5)",
      borderColor: "rgba(0, 217, 255, .5)",
      pointBackgroundColor: "rgba(0, 217, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 217, 255, .5)",
      data: [6, 0, 7, 5, 9, 4, 4],
    },
    {
      label: "A3/B4-04",
      backgroundColor: "rgba(255, 0, 217, .5)",
      borderColor: "rgba(255, 0, 217, .5)",
      pointBackgroundColor: "rgba(255, 0, 217, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 0, 217, .5)",
      data: [5, 0, 5, 6, 4, 4],
    },
    {
      label: "A3/B3-04",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [5, 0, 5, 3, 4, 4],
    },
    {
      label: "A1/B1-04",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [5, 0, 7, 4, 3, 4, 4],
    },
    {
      label: "B5-02",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [4, 0, 7, 0, 7, 3, 4],
    },
    {
      label: "B4-02",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [4, 0, 6, 3, 4],
    },
    {
      label: "B3-98/Issue-2",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .8)",
      pointBackgroundColor: "rgba(0, 104, 173, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .8)",
      data: [4, 0, 4, 3, 4],
    },
    {
      label: "B2-98/Issue-2",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .5)",
      pointBackgroundColor: "rgba(0, 104, 173, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .5)",
      data: [2, 0, 2, 3, 4],
    },
    {
      label: "B1-02",
      backgroundColor: "rgba(0, 255, 26, .5)",
      borderColor: "rgba(0, 255, 26, .5)",
      pointBackgroundColor: "rgba(0, 255, 26, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 26, .5)",
      data: [4, 0, 7, 2, 3, 4],
    },
    {
      label: "A5-02",
      backgroundColor: "rgba(0, 217, 255, .5)",
      borderColor: "rgba(0, 217, 255, .5)",
      pointBackgroundColor: "rgba(0, 217, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 217, 255, .5)",
      data: [0, 7, 5, 7, 3, 2],
    },
    {
      label: "A3-02",
      backgroundColor: "rgba(255, 0, 217, .5)",
      borderColor: "rgba(255, 0, 217, .5)",
      pointBackgroundColor: "rgba(255, 0, 217, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 0, 217, .5)",
      data: [0, 5, 6, 3, 2],
    },
    {
      label: "A2-96/Issue-3",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [0, 3, 3, 3, 2],
    },
    {
      label: "A1-02",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [0, 7, 4, 3, 2, 2],
    },
    {
      label: "SP",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .8)",
      pointBackgroundColor: "rgba(0, 104, 173, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .8)",
      data: [0, 4, 0, 8, 5, 2, 5],
    },
    {
      label: "SN-PLUS",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .5)",
      pointBackgroundColor: "rgba(0, 104, 173, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .5)",
      data: [0, 4, 0, 7, 4, 1, 3],
    },
    {
      label: "SN",
      backgroundColor: "rgba(0, 255, 26, .5)",
      borderColor: "rgba(0, 255, 26, .5)",
      pointBackgroundColor: "rgba(0, 255, 26, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 26, .5)",
      data: [0, 4, 0, 7, 4, 1, 3],
    },
    {
      label: "SM",
      backgroundColor: "rgba(0, 217, 255, .5)",
      borderColor: "rgba(0, 217, 255, .5)",
      pointBackgroundColor: "rgba(0, 217, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 217, 255, .5)",
      data: [0, 4, 0, 7, 3, 1, 3],
    },
    {
      label: "SL",
      backgroundColor: "rgba(255, 0, 217, .5)",
      borderColor: "rgba(255, 0, 217, .5)",
      pointBackgroundColor: "rgba(255, 0, 217, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 0, 217, .5)",
      data: [0, 0, 0, 5, 1, 1, 3],
    },
    {
      label: "SJ",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [0, 0, 0, 2, 1, 1, 2],
    },
    {
      label: "CF",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [0, 0, 0, 0, 3, 0, 0],
    },
    {
      label: "MB229.71(2019)",
      backgroundColor: "rgba(0, 217, 255, .5)",
      borderColor: "rgba(0, 217, 255, .5)",
      pointBackgroundColor: "rgba(0, 217, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 217, 255, .5)",
      data: [8, 6, 10, 10, 9, 10, 8],
    },
    {
      label: "MB229.61(2019)",
      backgroundColor: "rgba(255, 0, 217, .5)",
      borderColor: "rgba(255, 0, 217, .5)",
      pointBackgroundColor: "rgba(255, 0, 217, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 0, 217, .5)",
      data: [8, 6, 10, 10, 9, 10, 8, 8],
    },
    {
      label: "MB229.6(2019)",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [8, 0, 9, 7, 9, 10, 8],
    },
    {
      label: "MB229.52(2019)",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [8, 6, 8, 10, 9, 10, 8],
    },
    {
      label: "MB229.51(2019)",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .8)",
      pointBackgroundColor: "rgba(0, 104, 173, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .8)",
      data: [8, 6, 6, 8, 9, 10, 8],
    },
    {
      label: "MB229.5(2019)",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .5)",
      pointBackgroundColor: "rgba(0, 104, 173, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .5)",
      data: [8, 0, 6, 7, 9, 10, 8],
    },
    {
      label: "MB229.31(2019)",
      backgroundColor: "rgba(0, 255, 26, .5)",
      borderColor: "rgba(0, 255, 26, .5)",
      pointBackgroundColor: "rgba(0, 255, 26, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 26, .5)",
      data: [8, 6, 3, 7, 8, 8, 7],
    },
    {
      label: "MB229.31(2019)",
      backgroundColor: "rgba(0, 217, 255, .5)",
      borderColor: "rgba(0, 217, 255, .5)",
      pointBackgroundColor: "rgba(0, 217, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 217, 255, .5)",
      data: [8, 6, 3, 7, 8, 8, 7],
    },
    {
      label: "MB229.3(2019)",
      backgroundColor: "rgba(255, 0, 217, .5)",
      borderColor: "rgba(255, 0, 217, .5)",
      pointBackgroundColor: "rgba(255, 0, 217, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 0, 217, .5)",
      data: [8, 0, 3, 6, 7, 8, 7],
    },
    {
      label: "MB229.71(2016)",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [7, 6, 10, 10, 9, 10, 8],
    },
    {
      label: "MB229.6(2016)",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [7, 0, 9, 7, 9, 10, 8],
    },
    {
      label: "MB229.52(2016)",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [7, 6, 8, 10, 9, 10, 8],
    },
    {
      label: "MB229.51(2016)",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [7, 6, 6, 8, 9, 10, 8],
    },
    {
      label: "MB229.5(2016)",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .8)",
      pointBackgroundColor: "rgba(0, 104, 173, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .8)",
      data: [7, 0, 6, 7, 9, 10, 8],
    },
    {
      label: "MB229.31(2016)",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .5)",
      pointBackgroundColor: "rgba(0, 104, 173, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .5)",
      data: [7, 6, 3, 7, 8, 8, 7],
    },
    {
      label: "MB229.3(2016)",
      backgroundColor: "rgba(0, 255, 26, .5)",
      borderColor: "rgba(0, 255, 26, .5)",
      pointBackgroundColor: "rgba(0, 255, 26, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 26, .5)",
      data: [7, 0, 3, 6, 7, 8, 7],
    },
    {
      label: "MB229.1(2016)",
      backgroundColor: "rgba(0, 217, 255, .5)",
      borderColor: "rgba(0, 217, 255, .5)",
      pointBackgroundColor: "rgba(0, 217, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 217, 255, .5)",
      data: [7, 0, 5, 6, 7, 4, 7],
    },
    {
      label: "MB229.52(2012)",
      backgroundColor: "rgba(255, 0, 217, .5)",
      borderColor: "rgba(255, 0, 217, .5)",
      pointBackgroundColor: "rgba(255, 0, 217, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 0, 217, .5)",
      data: [7, 6, 7, 8, 8, 10, 8],
    },
    {
      label: "MB229.51(2012)",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [7, 6, 5, 7, 8, 10, 8],
    },
    {
      label: "MB229.5(2012)",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [7, 0, 5, 7, 8, 10, 8],
    },
    {
      label: "MB229.31(2012)",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .8)",
      pointBackgroundColor: "rgba(0, 104, 173, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .8)",
      data: [7, 6, 3, 6, 7, 8, 7],
    },
    {
      label: "MB229.3(2012)",
      backgroundColor: "rgba(0, 104, 173, .5)",
      borderColor: "rgba(0, 104, 173, .5)",
      pointBackgroundColor: "rgba(0, 104, 173, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 104, 173, .5)",
      data: [7, 0, 3, 6, 7, 8, 7],
    },
    {
      label: "MB229.1(2012)",
      backgroundColor: "rgba(0, 255, 26, .5)",
      borderColor: "rgba(0, 255, 26, .5)",
      pointBackgroundColor: "rgba(0, 255, 26, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 26, .5)",
      data: [7, 0, 0, 5, 6, 7, 4],
    },
    {
      label: "MB229.51(2009)",
      backgroundColor: "rgba(0, 217, 255, .5)",
      borderColor: "rgba(0, 217, 255, .5)",
      pointBackgroundColor: "rgba(0, 217, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 217, 255, .5)",
      data: [7, 6, 5, 7, 8, 10, 6],
    },
    {
      label: "MB229.5(2009)",
      backgroundColor: "rgba(255, 0, 217, .5)",
      borderColor: "rgba(255, 0, 217, .5)",
      pointBackgroundColor: "rgba(255, 0, 217, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 0, 217, .5)",
      data: [7, 0, 5, 7, 8, 10, 6],
    },
    {
      label: "MB229.31(2009)",
      backgroundColor: "rgba(255, 247, 0, .5)",
      borderColor: "rgba(255, 247, 0, .5)",
      pointBackgroundColor: "rgba(255, 247, 0, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 247, 0, .5)",
      data: [7, 6, 3, 6, 7, 8, 6],
    },
    {
      label: "MB229.3(2009)",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [7, 0, 3, 6, 7, 8, 6],
    },
    {
      label: "MB229.1(2009)",
      backgroundColor: "rgba(189, 66, 185, .5)",
      borderColor: "rgba(189, 66, 185, .5)",
      pointBackgroundColor: "rgba(189, 66, 185, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(189, 66, 185, .5)",
      data: [7, 0, 0, 5, 6, 7, 4],
    },
    {
      label: "VW51100(2018)",
      backgroundColor: "rgba(0, 89, 214, .5)",
      borderColor: "rgba(0, 89, 214, .5)",
      pointBackgroundColor: "rgba(0, 89, 214, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 89, 214, .5)",
      data: [8, 8, 2, 8, 10, 10, 8],
    },
    {
      label: "VW50500 (2014)/50501(2018)",
      backgroundColor: "rgba(255, 247, 0, .5)",
      borderColor: "rgba(255, 247, 0, .5)",
      pointBackgroundColor: "rgba(255, 247, 0, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 247, 0, .5)",
      data: [8, 6, 3, 8, 8, 10, 8],
    },
    {
      label: "VW50888 (2013)/VW50999 (2013)",
      backgroundColor: "rgba(112, 255, 10, .5)",
      borderColor: "rgba(112, 255, 10, .5)",
      pointBackgroundColor: "rgba(112, 255, 10, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(112, 255, 10, .5)",
      data: [8, 0, 0, 0, 10, 10, 8],
    },
    {
      label: "VW50800 (2018)/VW50900 (2018)",
      backgroundColor: "rgba(255, 247, 0, .5)",
      borderColor: "rgba(255, 247, 0, .5)",
      pointBackgroundColor: "rgba(255, 247, 0, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 247, 0, .5)",
      data: [8, 8, 10, 9, 8, 10, 8],
    },
    {
      label: "VW50601 (2000)/VW50301 (2000)",
      backgroundColor: "rgba(10, 177, 255, .5)",
      borderColor: "rgba(10, 177, 255, .5)",
      pointBackgroundColor: "rgba(10, 177, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(10, 177, 255, .5)",
      data: [4, 0, 5, 8, 8, 6, 10],
    },
    {
      label: "VW50600 (1999)/VW50300 (1999)",
      backgroundColor: "rgba(10, 255, 67, .5)",
      borderColor: "rgba(10, 255, 67, .5)",
      pointBackgroundColor: "rgba(10, 255, 67, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(10, 255, 67, .5)",
      data: [4, 0, 5, 8, 4, 6, 10],
    },
    {
      label: "VW50200 (2005)/VW50500 (2010)",
      backgroundColor: "rgba(10, 235, 255, .5)",
      borderColor: "rgba(10, 235, 255, .5)",
      pointBackgroundColor: "rgba(10, 235, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(10, 235, 255, .5)",
      data: [8, 0, 0, 8, 6, 7, 3],
    },
    {
      label: "VW50200 (1997)/VW50500 (1997)",
      backgroundColor: "rgba(255, 10, 226, .5)",
      borderColor: "rgba(255, 10, 226, .5)",
      pointBackgroundColor: "rgba(255, 10, 226, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 10, 226, .5)",
      data: [2, 0, 0, 8, 4, 5, 3],
    },
    {
      label: "VW50400 (2012)/VW50700 (2004)",
      backgroundColor: "rgba(0, 255, 26, .5)",
      borderColor: "rgba(0, 255, 26, .5)",
      pointBackgroundColor: "rgba(0, 255, 26, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 26, .5)",
      data: [8, 8, 5, 8, 8, 10, 10],
    },
    {
      label: "VW50400 (2012)/VW50700 (2015)",
      backgroundColor: "rgba(255, 10, 226, .5)",
      borderColor: "rgba(255, 10, 226, .5)",
      pointBackgroundColor: "rgba(255, 10, 226, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 10, 226, .5)",
      data: [8, 8, 5, 8, 8, 10, 10],
    },
    {
      label: "VW50400 (2020)/VW50700 (2020)",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [10, 8, 5, 10, 10, 10, 10],
    },
    {
      label: "VW50200 (2005)/VW50501 (2005)",
      backgroundColor: "rgba(109, 110, 113, .2)",
      borderColor: "rgba(109, 110, 113, .2)",
      pointBackgroundColor: "rgba(109, 110, 113, .2)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(34, 202, 236, 1)",
      data: [8, 6, 0, 8, 7, 7, 8],
    },
    {
      label: "VW50200 (1997)/VW50501 (1999)",
      backgroundColor: "rgba(255, 247, 0, .5)",
      borderColor: "rgba(255, 247, 0, .5)",
      pointBackgroundColor: "rgba(255, 247, 0, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 247, 0, .5)",
      data: [5, 5, 0, 8, 4, 5, 6],
    },
    {
      label: "VW50101 (2005)/VW50500 (2010)",
      backgroundColor: "rgba(109, 110, 113, .2)",
      borderColor: "rgba(109, 110, 113, .2)",
      pointBackgroundColor: "rgba(109, 110, 113, .2)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(34, 202, 236, 1)",
      data: [8, 0, 0, 5, 6, 7, 3],
    },
    {
      label: "VW50101 (1997)/VW50500 (1997)",
      backgroundColor: "rgba(239, 117, 255, .5)",
      borderColor: "rgba(239, 117, 255, .5)",
      pointBackgroundColor: "rgba(239, 117, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(239, 117, 255, .5)",
      data: [2, 0, 0, 3, 4, 6, 3],
    },
    {
      label: "VW50000 (1997)/VW50500 (1997)",
      backgroundColor: "rgba(200, 132, 55, .5)",
      borderColor: "rgba(200, 132, 55, .5)",
      pointBackgroundColor: "rgba(200, 132, 55, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(200, 132, 55, .5)",
      data: [2, 0, 0, 3, 4, 6, 3],
    },
    {
      label: "Longlife-17 FE+ (2018)",
      backgroundColor: "rgba(255, 136, 0,, .5)",
      borderColor: "rgba(255, 136, 0,, .5)",
      pointBackgroundColor: "rgba(255, 136, 0,, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 136, 0,, .5)",
      data: [8, 6, 10, 8, 10, 8, 8],
    },
    {
      label: "Longlife-14 FE+ (2018)",
      backgroundColor: "rgba(0, 255, 25, .5)",
      borderColor: "rgba(0, 255, 25, .5)",
      pointBackgroundColor: "rgba(0, 255, 25, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 25, .5)",
      data: [8, 6, 10, 8, 10, 8, 8],
    },
    {
      label: "Longlife-12 FE (2018)",
      backgroundColor: "rgba(0, 255, 247, .5)",
      borderColor: "rgba(0, 255, 247, .5)",
      pointBackgroundColor: "rgba(0, 255, 247, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 255, 247, .5)",
      data: [8, 6, 7, 8, 10, 8, 8],
    },
    {
      label: "Longlife-04 (2018)",
      backgroundColor: "rgba(107, 137, 255, .5)",
      borderColor: "rgba(107, 137, 255, .5)",
      pointBackgroundColor: "rgba(107, 137, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(107, 137, 255, .5)",
      data: [8, 6, 3, 8, 10, 8, 8],
    },
    {
      label: "Longlife-01 (2018)",
      backgroundColor: "rgba(245, 107, 255, .5)",
      borderColor: "rgba(245, 107, 255, .5)",
      pointBackgroundColor: "rgba(245, 107, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 107, 255, .5)",
      data: [8, 0, 7, 8, 10, 8, 8],
    },
    {
      label: "Longlife-01 FE (2018)",
      backgroundColor: "rgba(200, 0, 214, .5)",
      borderColor: "rgba(200, 0, 214, .5)",
      pointBackgroundColor: "rgba(200, 0, 214, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(200, 0, 214, .5)",
      data: [8, 0, 7, 8, 10, 8, 8],
    },
    {
      label: "Longlife-04",
      backgroundColor: "rgba(34, 202, 236, .2)",
      borderColor: "rgba(34, 202, 236, 1)",
      pointBackgroundColor: "rgba(34, 202, 236, 1)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(34, 202, 236, 1)",
      data: [8, 6, 3, 8, 8, 8, 7],
    },
    {
      label: "Longlife-01",
      backgroundColor: "rgba(255, 247, 0, .5)",
      borderColor: "rgba(255, 247, 0, .5)",
      pointBackgroundColor: "rgba(255, 247, 0, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 247, 0, .5)",
      data: [8, 0, 0, 8, 8, 8, 7],
    },
    {
      label: "Longlife-01 FE",
      backgroundColor: "rgba(214, 0, 0, .5)",
      borderColor: "rgba(214, 0, 0, .5)",
      pointBackgroundColor: "rgba(214, 0, 0, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(214, 0, 0, .5)",
      data: [8, 0, 7, 8, 8, 8, 7],
    },
    {
      label: "Longlife-98",
      backgroundColor: "rgba(146, 0, 214, .5)",
      borderColor: "rgba(146, 0, 214, .5)",
      pointBackgroundColor: "rgba(146, 0, 214, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(146, 0, 214, .5)",
      data: [4, 0, 0, 7, 4, 3, 4],
    },
    {
      label: "dexos 1",
      backgroundColor: "rgba(0, 129, 214, .5)",
      borderColor: "rgba(0, 129, 214, .5)",
      pointBackgroundColor: "rgba(0, 129, 214, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 129, 214, .5)",
      data: [0, 4, 9, 7, 5, 7, 8],
    },
    {
      label: "dexos 2",
      backgroundColor: "rgba(0, 8, 255, .5)",
      borderColor: "rgba(0, 8, 255, .5)",
      pointBackgroundColor: "rgba(0, 8, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 8, 255, .5)",
      data: [7, 6, 6, 7, 7, 7, 8],
    },
    {
      label: "B-040-2095",
      backgroundColor: "rgba(97, 97, 97, .5)",
      borderColor: "rgba(97, 97, 97, .5)",
      pointBackgroundColor: "rgba(97, 97, 97, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(97, 97, 97, .5)",
      data: [8, 0, 5, 8, 7, 4, 7],
    },
    {
      label: "B-040-2098",
      backgroundColor: "rgba(194, 152, 0, .5)",
      borderColor: "rgba(194, 152, 0, .5)",
      pointBackgroundColor: "rgba(194, 152, 0, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(194, 152, 0, .5)",
      data: [8, 0, 0, 5, 8, 4, 6],
    },
    {
      label: "M2C948-B",
      backgroundColor: "rgba(186, 255, 102, .5)",
      borderColor: "rgba(186, 255, 102, .5)",
      pointBackgroundColor: "rgba(186, 255, 102, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(186, 255, 102, .5)",
      data: [8, 6, 8, 5, 8, 7, 7],
    },
    {
      label: "M2C913-D",
      backgroundColor: "rgba(199, 102, 255, .5)",
      borderColor: "rgba(199, 102, 255, .5)",
      pointBackgroundColor: "rgba(199, 102, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(199, 102, 255, .5)",
      data: [7, 0, 8, 8, 7, 7, 7],
    },
    {
      label: "M2C913-C",
      backgroundColor: "rgba(100, 0, 158, .5)",
      borderColor: "rgba(100, 0, 158, .5)",
      pointBackgroundColor: "rgba(100, 0, 158, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(100, 0, 158, .5)",
      data: [8, 0, 8, 5, 7, 7, 6],
    },
    {
      label: "M2C913-B",
      backgroundColor: "rgba(173, 31, 255, .5)",
      borderColor: "rgba(173, 31, 255, .5)",
      pointBackgroundColor: "rgba(173, 31, 255, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(173, 31, 255, .5)",
      data: [4, 0, 7, 6, 4, 3, 4],
    },
    {
      label: "M2C913-A",
      backgroundColor: "rgba(255, 31, 162, .5)",
      borderColor: "rgba(255, 31, 162, .5)",
      pointBackgroundColor: "rgba(255, 31, 162, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 31, 162, .5)",
      data: [4, 0, 6, 3, 3, 3, 4],
    },
    {
      label: "RN17",
      backgroundColor: "rgba(66, 197, 22, .5)",
      borderColor: "rgba(66, 197, 22, .5)",
      pointBackgroundColor: "rgba(66, 197, 22, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(66, 197, 22, .5)",
      data: [7, 9, 3, 9, 8, 7, 8],
    },
    {
      label: "RN0700",
      backgroundColor: "rgba(37, 64, 173, .5)",
      borderColor: "rgba(37, 64, 173, .5)",
      pointBackgroundColor: "rgba(37, 64, 173, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(37, 64, 173, .5)",
      data: [7, 0, 0, 7, 7, 7, 6],
    },
    {
      label: "RN0710",
      backgroundColor: "rgba(37, 173, 91, .5)",
      borderColor: "rgba(37, 173, 91, .5)",
      pointBackgroundColor: "rgba(37, 173, 91, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(37, 173, 91, .5)",
      data: [8, 0, 0, 7, 7, 7, 6],
    },
    {
      label: "RN0720",
      backgroundColor: "rgba(53, 113, 156, .5)",
      borderColor: "rgba(53, 113, 156, .5)",
      pointBackgroundColor: "rgba(53, 113, 156, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(53, 113, 156, .5)",
      data: [7, 9, 3, 9, 8, 7, 6],
    },
    {
      label: "A40",
      backgroundColor: "rgba(152, 58, 61, .5)",
      borderColor: "rgba(152, 58, 61, .5)",
      pointBackgroundColor: "rgba(152, 58, 61, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(152, 58, 61, .5)",
      data: [0, 0, 0, 8, 8, 8, 8],
    },
    {
      label: "C40",
      backgroundColor: "rgba(0, 129, 209, .5)",
      borderColor: "rgba(0, 129, 209, .5)",
      pointBackgroundColor: "rgba(0, 129, 209, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(0, 129, 209, .5)",
      data: [8, 8, 2, 8, 10, 10, 8],
    },
    {
      label: "A30",
      backgroundColor: "rgba(86, 92, 0, .5)",
      borderColor: "rgba(86, 92, 0, .5)",
      pointBackgroundColor: "rgba(86, 92, 0, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(86, 92, 0, .5)",
      data: [7, 8, 5, 8, 8, 10, 10],
    },
    {
      label: "C20",
      backgroundColor: "rgba(245, 66, 66, .5)",
      borderColor: "rgba(245, 66, 66, .5)",
      pointBackgroundColor: "rgba(245, 66, 66, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(245, 66, 66, .5)",
      data: [8, 8, 10, 9, 8, 10, 9],
    },
    {
      label: "B71 2300(2019)",
      backgroundColor: "rgba(92, 0, 81, .5)",
      borderColor: "rgba(92, 0, 81, .5)",
      pointBackgroundColor: "rgba(92, 0, 81, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(92, 0, 81, .5)",
      data: [8, 0, 0, 6, 7, 7, 9],
    },
    {
      label: "B71 2296(2019)",
      backgroundColor: "rgba(255, 15, 15, .5)",
      borderColor: "rgba(255, 15, 15, .5)",
      pointBackgroundColor: "rgba(255, 15, 15, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(255, 15, 15, .5)",
      data: [8, 6, 3, 10, 8, 7, 9],
    },
    {
      label: "B71 2290(2019)",
      backgroundColor: "rgba(233, 203, 12, .5)",
      borderColor: "rgba(233, 203, 12, .5)",
      pointBackgroundColor: "rgba(233, 203, 12, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(233, 203, 12, .5)",
      data: [8, 6, 7, 10, 10, 7, 9],
    },
    {
      label: "B71 2297(2019)",
      backgroundColor: "rgba(243, 138, 32, .8)",
      borderColor: "rgba(243, 138, 32, .8)",
      pointBackgroundColor: "rgba(243, 138, 32, .8)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(243, 138, 32, .8)",
      data: [8, 7, 7, 10, 9, 7, 9],
    },
    {
      label: "B71 2312(2019)",
      backgroundColor: "rgba(26, 30, 224, .5)",
      borderColor: "rgba(26, 30, 224, .5)",
      pointBackgroundColor: "rgba(26, 30, 224, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(26, 30, 224, .5)",
      data: [8, 7, 7, 10, 10, 7, 9],
    },
    {
      label: "B71 2302(2019)",
      backgroundColor: "rgba(224, 89, 26, .5)",
      borderColor: "rgba(224, 89, 26, .5)",
      pointBackgroundColor: "rgba(224, 89, 26, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(224, 89, 26, .5)",
      data: [8, 7, 7, 10, 10, 7, 8],
    },
    {
      label: "B71 2010(2019)",
      backgroundColor: "rgba(173, 158, 20, .5)",
      borderColor: "rgba(173, 158, 20, .5)",
      pointBackgroundColor: "rgba(173, 158, 20, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(173, 158, 20, .5)",
      data: [8, 8, 10, 10, 9, 7, 9],
    },
    {
      label: "B71 2296(2013)",
      backgroundColor: "rgba(232, 59, 223, .5)",
      borderColor: "rgba(232, 59, 223, .5)",
      pointBackgroundColor: "rgba(232, 59, 223, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(232, 59, 223, .5)",
      data: [7, 0, 0, 8, 8, 7, 8],
    },
    {
      label: "B71 2290(2013)",
      backgroundColor: "rgba(59, 232, 194, .5)",
      borderColor: "rgba(59, 232, 194, .5)",
      pointBackgroundColor: "rgba(59, 232, 194, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(59, 232, 194, .5)",
      data: [7, 6, 7, 8, 8, 7, 8],
    },
    {
      label: "B71 2312(2013)",
      backgroundColor: "rgba(183, 232, 59, .5)",
      borderColor: "rgba(183, 232, 59, .5)",
      pointBackgroundColor: "rgba(183, 232, 59, .5)",
      pointBorderColor: "#fff",
      pointHoverBackgroundColor: "#fff",
      pointHoverBorderColor: "rgba(183, 232, 59, .5)",
      data: [7, 7, 7, 8, 8, 7, 9],
    },
  ],
};
export const RadarOptions = {
  scale: {
    ticks: {
      min: 0,
      max: 10,
      stepSize: 2,
      showLabelBackdrop: false,
      backdropColor: "rgba(203, 197, 11, 1)",
        },
    angleLines: {
      color: "#C3C3C4",
      lineWidth: 1.5,
    },
    gridLines: {
      color: "#C3C3C4",
      linear: true,
      lineWidth: 1.5,

    },
    pointLabels: {
      fontSize: 18,
    }
  },
};
